$('.tooltip label').each(function (_, value) {
  $(value).append('<i class="fa fa-question-circle"></i>')
})

if ($(window).width() > 484) {
  $('.tooltip label i').hover(function () {
    $(this).closest('.tooltip').find('.hint').show()
  })

  $('.tooltip label i').mouseleave(function () {
    $(this).closest('.tooltip').find('.hint').hide()
  })
} else {
  $('.tooltip label i').click(function () {
    $('.modal-wrapper.tooltip h2').html($(this).parent().text())
    $('.modal-wrapper.tooltip p').html($(this).closest('.tooltip').find('.hint').html())
    $('.modal-wrapper.tooltip').fadeToggle('fast')
  })
}
